<template>
  <v-row no-gutters>
    <v-col cols="8">
      <v-list-item>
        <v-list-item-icon>
          <v-icon v-if="icon" size="32">{{ icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle>{{ title }}</v-list-item-subtitle>
          <v-list-item-title v-if="newValue.length" class="mt-2">{{ formatDate(newValue) }}</v-list-item-title>
          <v-list-item-title v-else>--</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col v-if="!readonly" cols="4" align-self="center" class="d-flex justify-center">
      <v-row
        align="center"
        justify="end"
        no-gutters
      >
        <v-btn class="black--text justify-end" plain rounded @click="popup = true">
          <v-icon color="black">mdi-plus</v-icon>
        </v-btn>

        <v-overlay
          :value="popup"
          opacity="0.5"
        >
          <v-card
            light
          >
            <v-container class="px-2">
              <v-card-title class="full-width">
                <span class="d-flex justify-center flex-grow-1">{{ title }}</span>
                <v-icon size="28" color="third" class="justify-end" @click="closeOverlay">mdi-close</v-icon>
              </v-card-title>

              <v-card-text>
                <v-date-picker
                  v-model="newValue"
                  color="third"
                  range
                  @click:date="selectDate"
                />
              </v-card-text>
            </v-container>
          </v-card>
        </v-overlay>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { ref, watch } from '@vue/composition-api';
import { getUnixTime, parseISO, format } from 'date-fns';

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: null
    },
    readonly: { type: Boolean },
    icon: {
      type: String,
      default: null
    }
  },
  setup (props, context) {
    const popup = ref(false);
    const date = props.value.length ? props.value.map(value => format(new Date(value * 1000), 'yyyy-MM-dd')) : props.value;
    const newValue = ref(date);

    watch(newValue, (newVal, oldVal) => {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        const unixDates = newValue.value.map(unixDate => getUnixTime(new Date(parseISO(unixDate))));
        context.emit('input', unixDates);
      }
    });

    watch(() => props.value, (newVal, oldVal) => {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        newValue.value = props.value ? props.value.map(value => format(new Date(value * 1000), 'yyyy-MM-dd')) : [];
      }
    });

    const closeOverlay = () => {
      popup.value = false;
    };

    const selectDate = () => {
      if (newValue.value.length > 1) {
        popup.value = false;
      }
    };

    const formatDate = selectedDates => {
      if (selectedDates.length === 1) {
        return format(new Date(selectedDates[0]), 'dd/MM/yyyy');
      }
      return `${format(new Date(selectedDates[0]), 'dd/MM/yyyy')} - ${format(new Date(selectedDates[1]), 'dd/MM/yyyy')}`;
    };

    return { selectDate, popup, closeOverlay, newValue, formatDate };
  }
};
</script>
